import React, { Component } from "react";
import { Button, Input, Row, Col } from "antd";
import { createHashHistory } from "history";

export const history = createHashHistory();

const styles = {
  name: {
    verticalAlign: "top",
    display: "none",
    margin: 0,
    border: "none",
    fontSize: "16px",
    fontFamily: "Montserrat",
    padding: "16px",
    color: "rgba(0, 0, 0, 0.65)",
    backgroundColor: "transparent",
    lineHeight: "1.15em",
    placeholderColor: "rgba(0, 0, 0, 0.65)",
    _webkitFontSmoothing: "antialiased",
    _mozOsxFontSmoothing: "grayscale",
  },
  leftCenter: {
    float: "left",
    textAlign: "center",
  },
  blockRight: {
    display: "block",
    float: "right",
  },
  center: {
    textAlign: "center",
  },
};

export default class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardBrand: "",
      nonce: undefined,
      googlePay: false,
      applePay: false,
      masterpass: false,
    };
    this.requestCardNonce = this.requestCardNonce.bind(this);
  }

  requestCardNonce() {
    this.paymentForm.requestCardNonce();
  }

  componentDidMount() {
    const config = {
      applicationId: "sq0idp-wbEZvhfBmYwA9YwGWs-BYA",
      // applicationId: "sandbox-sq0idb-euwwfdt8mC55KISk5C4zzQ",
      locationId: "BHPDZGABESN2F",
      inputClass: "input-square",
      autoBuild: false,
      inputStyles: [
        {
          fontSize: "16px",
          padding: "16px 0px 16px 0px",
          color: "rgba(100, 100, 100, 0.65)",
          backgroundColor: "transparent",
          lineHeight: "1.15em",
          placeholderColor: "rgba(0, 0, 0, 0.65)",
          _webkitFontSmoothing: "antialiased",
          _mozOsxFontSmoothing: "grayscale",
        },
      ],
      applePay: {
        elementId: "sq-apple-pay",
      },
      masterpass: {
        elementId: "sq-masterpass",
      },
      googlePay: {
        elementId: "sq-google-pay",
      },
      cardNumber: {
        elementId: "sq-card-number",
        placeholder: "Card Number",
      },
      cvv: {
        elementId: "sq-cvv",
        placeholder: "CVV",
      },
      expirationDate: {
        elementId: "sq-expiration-date",
        placeholder: "MM/YY",
      },
      postalCode: {
        elementId: "sq-postal-code",
        placeholder: "Zip",
      },
      callbacks: {
        methodsSupported: (methods) => {
          if (methods.googlePay) {
            this.setState({
              googlePay: methods.googlePay,
            });
          }
          if (methods.applePay) {
            this.setState({
              applePay: methods.applePay,
            });
          }
          if (methods.masterpass) {
            this.setState({
              masterpass: methods.masterpass,
            });
          }
          return;
        },
        createPaymentRequest: () => {
          return {
            requestShippingAddress: false,
            requestBillingInfo: true,
            currencyCode: "USD",
            countryCode: "US",
            total: {
              label: "MERCHANT NAME",
              amount: "100",
              pending: false,
            },
            lineItems: [
              {
                label: "Subtotal",
                amount: "100",
                pending: false,
              },
            ],
          };
        },
        cardNonceResponseReceived: (errors, nonce, cardData) => {
          if (errors) {
            // Log errors from nonce generation to the Javascript console
            console.log("Encountered errors:");
            errors.forEach(function (error) {
              console.log("  " + error.message);
            });

            return;
          }
          //   this.setState({
          //     nonce: nonce
          //   });

          console.log(nonce);

          var dataToBesent = JSON.parse(
            localStorage.getItem("TotalFinalOrder") || "[]"
          );
          localStorage.setItem("tok", nonce);
          fetch("https://bensburrito.com/payment/process-payment", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization:
                "Bearer EAAAEOc59AwksuuKIYNrhgK9SPSPxWf6kfFSha-2i0ljYBx56RFbrrOC_E3ADzcb",
            },
            body: JSON.stringify({
              nonce: nonce,
              data: dataToBesent.orderdetails,
              tip: this.props.tip,
            }),
          })
            .catch((err) => {
              alert("Network error: " + err);
            })
            .then((response) => {
              if (!response.ok) {
                return response
                  .text()
                  .then((errorInfo) => Promise.reject(errorInfo));
              }
              return response.text();
            })
            .then((data) => {
              console.log(JSON.stringify(data));

              history.push({
                pathname: "/orderconfirm",
              });
            })
            .catch((err) => {
              console.error(err);
              alert(
                "Payment failed to complete!\nCheck browser developer console form more details"
              );
            });
          this.setState({
            nonce: nonce,
          });
        },
        unsupportedBrowserDetected: () => {},
        inputEventReceived: (inputEvent) => {
          switch (inputEvent.eventType) {
            case "focusClassAdded":
              break;
            case "focusClassRemoved":
              break;
            case "errorClassAdded":
              document.getElementById("error").innerHTML =
                "Please fix card information errors before continuing.";
              break;
            case "errorClassRemoved":
              document.getElementById("error").style.display = "none";
              break;
            case "cardBrandChanged":
              if (inputEvent.cardBrand !== "unknown") {
                this.setState({
                  cardBrand: inputEvent.cardBrand,
                });
              } else {
                this.setState({
                  cardBrand: "",
                });
              }
              break;
            case "postalCodeChanged":
              break;
            default:
              break;
          }
        },
        paymentFormLoaded: function () {
          document.getElementById("name").style.display = "inline-flex";
        },
      },
    };
    this.paymentForm = new this.props.paymentForm(config);
    this.paymentForm.build();
  }

  render() {
    return (
      <div className="container">
        <div id="form-container">
          <div id="sq-walletbox" style={{ display: "none" }}>
            <button
              style={{ display: this.state.applePay ? "inherit" : "none" }}
              className="wallet-button"
              id="sq-apple-pay"
            />
            <button
              style={{ display: this.state.masterpass ? "block" : "none" }}
              className="wallet-button"
              id="sq-masterpass"
            />
            <button
              style={{ display: this.state.googlePay ? "inherit" : "none" }}
              className="wallet-button"
              id="sq-google-pay"
            />
            <hr />
          </div>

          <div id="sq-ccbox">
            {/* <p>
              <span style={styles.leftCenter}>Enter Card Info Below </span>
              <span style={styles.blockRight}>
                {this.state.cardBrand.toUpperCase()}
              </span>
            </p> */}
            <div>
              <Row id="cc-field-wrapper" style={{ width: "100%" }}>
                <Col style={{ display: "none" }} span={24}>
                  <Input id="name" placeholder="Card Holder Name" />
                </Col>
                <Col span={24}>
                  <div
                    style={{ width: "89%" }}
                    className=""
                    id="sq-card-number"
                  />
                </Col>
                <Row gutter={16}>
                  <Col span={12}>
                    <div
                      style={{ width: "70%" }}
                      className=""
                      id="sq-expiration-date"
                    />
                  </Col>
                  <Col span={12}>
                    <div style={{ width: "70%" }} className="" id="sq-cvv" />
                  </Col>
                </Row>
                <Col span={24}>
                  <div
                    style={{ width: "89%" }}
                    className=""
                    id="sq-postal-code"
                  />
                </Col>
              </Row>
              <input type="hidden" id="card-nonce" name="nonce" />
            </div>
          </div>
          {/* <button
            className="button-credit-card"
            onClick={this.requestCardNonce}
          >
            Pay
          </button> */}
          <div
            className="btn-drawer btn-payment"
            style={{ textAlign: "center", marginTop: "45px" }}
          >
            <Row>
              <Col span={12}>
                <Button style={{ width: "90px" }} className="round-white-btn">
                  Back
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  style={{ width: "90px" }}
                  onClick={this.requestCardNonce}
                  className="round-orange-btn"
                >
                  Confirm
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        <p style={styles.center} id="error" />
      </div>
    );
  }
}
